{
  "name": "continuous-integration",
  "hostname": "ci.safarilaw.com",
  "development": true,
  "production": false,
  "applicationName": "Safari SOP",
  "sourceVersion": "a63af5d9bce76c82e12c5325eeda4c7da156e00e",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.ci.safarilaw.com/_api/comanage/",
    "apiRootLpms": "https://@.ci.safarilaw.com/_api/lpms/",
    "apiRootSquirrel": "https://@.ci.safarilaw.com/_api/squirrel/",
    "apiRootRms": "https://@.ci.serveport.com/_api/rms/"
  },
  "auth0": {
    "authorityRoot": "safarilaw-ci.auth0.com",
    "clientId": "JGVozqqiPRJkeoTfLYXi0S6a1XQiBvC7",
    "useLocalStorageCache": true
  },
  "auth": {
    "inactivityTimeout": 15,
    "inactivityWarning": 2
  },
  "statusApp": {
    "apiRootUrl": "https://@.ci.safarilaw.com/_api/maintenance/",
    "code": "_otSSDT9qMnGUM_kQKRl_NtGP_X0QjQfP2MT36jevuGnAzFuuPbGmA==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": true,
    "devTools": true,
    "devExceptions": true,
    "enableMatterSubtypePicklistSettingsEditing": true,
    "showMatterSubtypePicklistSettings": true,
    "showCustomPicklistSettings": true,
    "enableCustomPicklistSettingsEditing": true,
    "whiteRhinoAnswers": true,
    "showAccountBalanceAndOffset": true
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "029d8bde-aa1d-49b5-b5cf-aea4429d0ebb"
    },
    "appInsights": {
      "instrumentationKey": "57351800-d3f6-4057-9235-ef1c2d5d6061"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "showSwWarning": true,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 25,
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self"
    },
    "reports": {
      "key": "Z7EC-XGIC55-0N4F3F-1V0I54-5H0S6L-2A2S08-3C0O26-4D5X6H-41036E-4M3C3L"
    },
    "ckeditor": {
      "key": "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3NTY5NDM5OTksImp0aSI6IjRlYWQ3ZWZkLTVmNDMtNDUyNi05MDcyLWMzZjRkYzI1NjdhMyIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsic2giLCJkcnVwYWwiXSwid2hpdGVMYWJlbCI6dHJ1ZSwibGljZW5zZVR5cGUiOiJkZXZlbG9wbWVudCIsImZlYXR1cmVzIjpbIkRSVVAiXSwidmMiOiI4ZDZkNjBmZSJ9.02Q0b5zNer1MnKCH-EuqSys3qVXWK9C5IzvbafCqLQgFDjvfL8u9p_axz6tIj9Vg0N1m11R0q9ZiEvkF6RpWsw"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "lpms",
        "name": "matters",
        "url": "signalr/matters"
      },
      {
        "api": "lpms",
        "name": "correspondences",
        "url": "signalr/correspondences"
      }
    ]
  }
}
